import { render, staticRenderFns } from "./CategoryListItem.vue?vue&type=template&id=6d8f3aee&scoped=true"
import script from "./CategoryListItem.vue?vue&type=script&lang=js"
export * from "./CategoryListItem.vue?vue&type=script&lang=js"
import style0 from "./CategoryListItem.vue?vue&type=style&index=0&id=6d8f3aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f3aee",
  null
  
)

export default component.exports